import React, { useCallback, useEffect, useState } from 'react';
import { Header } from './components/Header';
import { Hero } from './components/Hero';
import { BenefitsSection } from './components/BenefitsSection';
import { ControlSection } from './components/ControlSection';
import { HowItWorks } from './components/HowItWorks';
import { TechnologySection } from './components/TechnologySection';
import { CredibilitySection } from './components/CredibilitySection';
import { LeadFormSection } from './components/LeadFormSection';
import { FAQSection } from './components/FAQSection';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
import { StickyMobileCTA } from './components/StickyMobileCTA';
import { BookingModal } from './components/BookingModal';
import { heroVersions } from './data/heroVersions';
import { useScrollDepth } from './hooks/useScrollDepth';
import { scrollToId } from './utils/scroll';
import { track } from './utils/tracking';
import { initMetaPixel } from './utils/metaPixel';

/** Meta ad angle: A = independence, B = AI and follow-up, C = marketing, D = systems and support. */
type AdVersion = 'A' | 'B' | 'C' | 'D';
interface AppProps {
  adVersion?: AdVersion;
  showStickyMobileCta?: boolean;
}
export function App({
  adVersion = 'A',
  showStickyMobileCta = true
}: AppProps) {
  const [bookingOpen, setBookingOpen] = useState(false);
  const copy = heroVersions[adVersion];
  useScrollDepth();
  useEffect(() => {
    initMetaPixel();
    track('landing_page_view', {
      ad_version: adVersion
    });
  }, [adVersion]);
  const onFormCta = useCallback((source: string) => {
    if (source.startsWith('hero')) {
      track('hero_cta_click', {
        source
      });
    }
    scrollToId('lead-form');
  }, []);
  const onBookCall = useCallback((source: string) => {
    track('calendar_click', {
      source
    });
    setBookingOpen(true);
  }, []);
  return <div className="w-full bg-white pb-[68px] md:pb-0" data-id="element-0" data-mp="nxwvvh10nctl">
      <Header onFormCta={onFormCta} data-id="element-1" data-mp="stc864jdl0nw" />

      <main data-id="element-2" data-mp="swgk5o3310p4">
        <Hero copy={copy} onFormCta={onFormCta} onBookCall={onBookCall} data-id="element-3" data-mp="36hvn4muyo06" />
        <BenefitsSection onFormCta={onFormCta} data-id="element-4" data-mp="38kxqn1ac7l9" />
        <ControlSection onFormCta={onFormCta} data-id="element-5" data-mp="3udkos1m9b4d1" />
        <HowItWorks data-id="element-6" data-mp="3uevrrz7vo833" />
        <TechnologySection onFormCta={onFormCta} data-id="element-7" data-mp="d4nvzht0nm2x" />
        <CredibilitySection data-id="element-8" data-mp="d3cwhu6lt0hm" />
        <LeadFormSection data-id="element-9" data-mp="d2l7513lnyzs" />
        <FAQSection data-id="element-10" data-mp="85ujnspgu14c" />
        <FinalCTA onFormCta={onFormCta} onBookCall={onBookCall} data-id="element-11" data-mp="85b8qvy8gczt" />
      </main>

      <Footer data-id="element-12" data-mp="3gl4pnbwh7qhe" />

      {showStickyMobileCta && <StickyMobileCTA onFormCta={onFormCta} onBookCall={onBookCall} data-id="element-13" data-mp="3glwd1zfx6hwl" />}
      <BookingModal open={bookingOpen} onClose={() => setBookingOpen(false)} data-id="element-14" data-mp="3bn2ye3owckuu" />
    </div>;
}